// ============================================================
//  AUTH-CONTEXT — Redaktions-Login (Firebase Auth, Email-Link)
//  Rolle kommt aus dem Custom Claim "role" (gesetzt von der
//  Cloud Function acceptInvite), NICHT aus einem Firestore-Feld.
// ============================================================
import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut as firebaseSignOut } from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUser(null);
        setRole(null);
        setLoading(false);
        return;
      }
      // Token frisch holen, damit ein gerade erst gesetzter Custom Claim
      // (durch acceptInvite) sofort sichtbar ist.
      const tokenResult = await firebaseUser.getIdTokenResult(true);
      setUser(firebaseUser);
      setRole(tokenResult.claims.role || null);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  async function signOut() {
    await firebaseSignOut(auth);
  }

  return (
    <AuthContext.Provider value={{ user, role, loading, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth() muss innerhalb von <AuthProvider> verwendet werden.");
  return ctx;
}
